import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';

import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertApprovedOnPaperDocumentsFormValueToKnmData = (
  values: IKnmErknmForm,
): IKnm248['approvedOnPaperDocuments'] => {
  const { approvedOnPaperDocuments } = values;

  if (!approvedOnPaperDocuments) {
    return null;
  }

  return approvedOnPaperDocuments?.attachments
    ? {
        active: approvedOnPaperDocuments?.active || null,
        attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(approvedOnPaperDocuments?.attachments),
        correlationToken: approvedOnPaperDocuments?.correlationToken || null,
        description: approvedOnPaperDocuments?.description || null,
        guid: approvedOnPaperDocuments?.guid || null,
        type: null,
      }
    : null;
};
